import type { LaserIoRefCode } from '@/constants/general'

export const FEATURE_FLAG_CLIENT = 'ld-onboarding-micro-frontends-client'

export const FEATURE_FLAG_KEYS = {
  saltString: 'onbp-release-portal-oobe-salt-string',
  fwuIorefLaser: 'omfe-release-fwupdatechoice-ioref-laser',
} as const

export const DEFAULT_FLAGS = {
  [FEATURE_FLAG_KEYS.saltString]: '',
  [FEATURE_FLAG_KEYS.fwuIorefLaser]: {} as Record<string, LaserIoRefCode>,
}

export type Flags = typeof FEATURE_FLAG_KEYS
export type DefaultFlags = typeof DEFAULT_FLAGS
